<template>
  <v-container fluid full-height grid-list-md>
    <v-layout row wrap>
      <v-flex xs6>
        <div class="text-xs-left">
          <v-breadcrumbs :items="breadcrumbs" divider=">"></v-breadcrumbs>
        </div>
      </v-flex>
      <v-flex xs6>
        <div style="display: flex; justify-content: flex-end">
          <v-menu offset-y>
            <template v-slot:activator="{ on, attrs }">
              <v-btn
                color="success"
                :loading="buttonLoading"
                v-bind="attrs"
                v-on="on"
              >
                <v-icon>cloud_download</v-icon>Export
              </v-btn>
            </template>

            <v-list>
              <v-list-tile @click="reprintSaleReportByCategory('printReport')">
                <v-list-tile-content>
                  <v-list-tile-title>PRINT ALL</v-list-tile-title>
                </v-list-tile-content>
              </v-list-tile>
            </v-list>
          </v-menu>
          <v-btn @click="showFilters = !showFilters" color="#FF4545">
            <v-icon>filter_list</v-icon>Filter
            <v-icon>{{
              showFilters ? "arrow_drop_up" : "arrow_drop_down"
            }}</v-icon>
          </v-btn>
        </div>
      </v-flex>
      <v-flex xs12 v-if="showFilters">
        <v-card>
          <v-layout row wrap class="pa-3">
            <v-flex sm3>
              <v-menu
                :nudge-right="40"
                lazy
                transition="scale-transition"
                offset-y
                full-width
                min-width="290px"
              >
                <v-text-field
                  slot="activator"
                  v-model="queryParams.fromDate"
                  label="From Date"
                  prepend-icon="event"
                  readonly
                ></v-text-field>
                <v-date-picker v-model="queryParams.fromDate"></v-date-picker>
              </v-menu>
            </v-flex>
            <v-flex sm3>
              <v-menu
                :nudge-right="40"
                lazy
                transition="scale-transition"
                offset-y
                full-width
                min-width="290px"
              >
                <v-text-field
                  slot="activator"
                  v-model="queryParams.toDate"
                  label="To Date"
                  prepend-icon="event"
                  readonly
                ></v-text-field>
                <v-date-picker v-model="queryParams.toDate"></v-date-picker>
              </v-menu>
            </v-flex>
            <v-flex sm3>
              <v-autocomplete
                v-model="queryParams.categoryIds"
                :items="categoryList"
                label="Category"
                item-text="name"
                item-value="id"
                multiple
                menu-props="auto"
                autocomplete
              ></v-autocomplete>
            </v-flex>
            <v-flex sm3>
              <v-select
                :items="shopList"
                label="Choose Shop..."
                item-text="name"
                menu-props="auto"
                item-value="id"
                :readonly="user.role.roleName == 'BRANCH_ADMIN'"
                v-model="queryParams.shopId"
              ></v-select>
            </v-flex>
            <v-flex sm3>
              <v-btn outline color="primary" @click="onSearch">
                Search
                <v-icon right>search</v-icon>
              </v-btn>
            </v-flex>
          </v-layout>
        </v-card>
      </v-flex>
      <v-flex xs12>
        <v-card>
          <v-card-title class="blue darken-3">
            <span class="headline white--text">Summary</span>
            <v-spacer></v-spacer>
            <v-icon @click="show = !show" class="white--text">{{
              show ? "keyboard_arrow_up" : "keyboard_arrow_down"
            }}</v-icon>
          </v-card-title>
          <v-card-text class="font-weight-bold" v-show="show">
            <div>
              <span>Grand Total:</span>
              <v-chip>
                <span>{{ grandTotal | decFormat(6) }}</span>
              </v-chip>
            </div>
          </v-card-text>
        </v-card>
      </v-flex>
      <v-flex xs12 class="mt-1">
        <v-card>
          <v-data-table
            :headers="headers"
            :items="saleAnalysisReportList"
            class="elevation-1"
            :loading="showListLoading"
            :total-items="totalRows"
            :rows-per-page-items="rowsPerPageItems"
            :pagination.sync="pagination"
            :must-sort="true"
          >
            <template slot="items" slot-scope="props">
              <td>{{ props.item.categoryCode }}</td>
              <td>{{ props.item.categoryName }}</td>
              <td>{{ props.item.amount | decFormat(6) }}</td>
            </template>
          </v-data-table>
        </v-card>
      </v-flex>
    </v-layout>

    <!-- <summary report> -->
    <div
      id="printReport"
      style="border: 1px solid black; width: 300px"
      v-show="false"
    >
      <div style="text-align: center">
        <p style="font-size: 15px; margin: 1px">{{ shopName }}</p>
      </div>
      <div style="text-align: center">
        <p style="font-size: 15px; margin: 1px">Sale Report By Category</p>
      </div>
      <div style="text-align: center">
        <p style="font-size: 15px; margin: 1px">
          Date From: [{{ queryParams.fromDate }}] To: [{{ queryParams.toDate }}]
        </p>
      </div>
      <br />
      <div style="padding-left: 5px; padding-right: 5px">
        <table
          style="
            font-family: arial, sans-serif;
            border-collapse: collapse;
            width: 100%;
            font-size: 12px;
            border-top: 1px solid black;
          "
        >
          <thead
            style="border-bottom: 1px solid black; border-top: 1px solid black"
          >
            <tr>
              <th style="border: 1px solid black; text-align: center">
                Category Code
              </th>
              <th style="border: 1px solid black; text-align: center">
                Category Name
              </th>
              <th style="border: 1px solid black; text-align: center">
                Amount
              </th>
            </tr>
          </thead>
          <tbody>
            <tr v-for="(item, i) in allSaleAnalysisReportPageList" :key="i">
              <td style="border: 1px solid black; text-align: left">
                {{ item.categoryCode }}
              </td>
              <td style="border: 1px solid black; text-align: left">
                {{ item.categoryName }}
              </td>
              <td style="border: 1px solid black; text-align: right">
                {{ item.amount | decFormat(6) }}
              </td>
            </tr>
            <tr>
              <td
                style="
                  border: 1px solid black;
                  font-weight: bold;
                  text-align: right;
                "
                colspan="2"
              >
                Grand Total
              </td>
              <td
                style="
                  border: 1px solid black;
                  font-weight: bold;
                  text-align: right;
                "
              >
                {{ grandTotal | decFormat(6) }}
              </td>
            </tr>
          </tbody>
        </table>
      </div>
    </div>
  </v-container>
</template>

<script>
import { commonService } from "../../services/common-service";
import { categoryService } from "../../services/category-service";
import { shopService } from "../../services/shop-service";
import { saleReportService } from "../../services/sale-report-service";
export default {
  name: "SaleReportByCategory",
  components: {},

  data: () => ({
    showListLoading: false,
    buttonLoading: false,
    showProductListDialog: false,
    user: JSON.parse(localStorage.getItem("user")),
    showFilters: false,
    show: false,
    breadcrumbs: [
      {
        text: "Report",
        disabled: true,
      },
      {
        text: "Sale Reports",
        disabled: true,
      },
      {
        text: "Sale Report By Category",
        disabled: true,
      },
    ],
    headers: [
      { text: "Category Code", align: "left", value: "categoryCode" },
      { text: "Category Name", align: "left", value: "categoryName" },
      { text: "Amount", align: "left", value: "amount" },
    ],
    rowsPerPageItems: [25, 50, 100],
    pagination: {
      descending: false,
      page: 1,
      rowsPerPage: 50,
      sortBy: "null",
      totalItems: 0,
    },
    totalRows: 0,
    queryParams: {
      fromDate: commonService.formatDate(new Date(), "YYYY-MM-DD"),
      toDate: commonService.formatDate(new Date(), "YYYY-MM-DD"),
      productIds: [],
      categoryIds: [],
      shopId: "",
    },
    grandTotal: 0,
    shopName: "",
    categoryList: [],
    saleAnalysisReportList: [],
    allSaleAnalysisReportPageList: [],
    decimalFormat: "",

    clonequeryParams: new Object(),
    shopList: [],
    customerName: "",
    filterCategory: "ALL",
  }),
  watch: {
    pagination: {
      handler() {
        this.getSaleReportByCategory();
      },
      deep: true,
    },
  },

  created() {
    if (this.user.role.roleName == "BRANCH_ADMIN") {
      this.queryParams.shopId = this.user.shopId;
    }
    //for deep linking
    if (this.$route.query.fromDate) {
      this.queryParams.fromDate = this.$route.query.fromDate;
    }
    if (this.$route.query.toDate) {
      this.queryParams.toDate = this.$route.query.toDate;
    }
    if (this.$route.query.page) {
      this.pagination.page = this.$route.query.page;
    }
    if (this.$route.query.size) {
      this.pagination.size = this.$route.query.size;
    }
    this.decimalFormat = commonService.formatdecimal();
    this.getCategoriesByStatus();
    this.getAllShop().then(() => {
      this.onSearch();
    });
  },
  methods: {
    onSearch() {
      this.queryParams.page = this.pagination.page;
      this.queryParams.size = this.pagination.rowsPerPage;
      this.$router.replace({
        name: "sale-report-by-category",
        query: this.queryParams,
      });
      this.getSaleReportByCategory();
      this.clonequeryParams = JSON.parse(JSON.stringify(this.queryParams));
      this.shopName = "";
      let shop = commonService.search(
        "id",
        this.queryParams.shopId,
        this.shopList
      );
      this.shopName = shop.name;
    },
    getCategoriesByStatus() {
      return categoryService
        .getCategoriesByStatus("ACTIVE")
        .then((res) => {
          this.categoryList = res.data;
        })
        .catch((err) => {
          console.error(err);
        });
    },

    getSaleReportByCategory() {
      this.showListLoading = true;
      let order = this.pagination.descending ? "desc" : "asc";
      saleReportService
        .getSaleReportByCategory(
          this.queryParams,
          this.pagination.page,
          this.pagination.rowsPerPage,
          this.pagination.sortBy + "," + order
        )
        .then((res) => {
          if (res.data) {
            this.saleAnalysisReportList = res.data.saleAnalysisReportList;
            this.grandTotal = res.data.totalAmount;
            this.totalRows = res.data.totalElements;
          }
        })
        .catch((err) => {
          console.log(err);
        })
        .finally(() => {
          this.showListLoading = false;
        });
    },

    getAllShop() {
      return shopService
        .getAllShop()
        .then((res) => {
          this.shopList = res.data;
          if (this.shopList.length > 0)
            this.queryParams.shopId = this.shopList[0].id;
        })
        .catch((err) => {
          console.log(err);
          if (err.response.data) {
            this.responseError = err.response.data.message;
          }
        });
    },

    reprintSaleReportByCategory(divName) {
      this.buttonLoading = true;
      saleReportService
        .getAllSaleReportByCategory(this.clonequeryParams)
        .then((res) => {
          this.allSaleAnalysisReportPageList = res.data.saleAnalysisReportList;
          this.grandTotal = res.data.totalAmount;
        })
        .catch((err) => {
          console.log(err);
        })
        .finally(() => {
          var printContents = document.getElementById(divName).innerHTML;
          var reprintWindow = window.open(
            "",
            "MsgWindow",
            "width=500,height=500"
          );
          reprintWindow.document.write(printContents);
          setTimeout(() => {
            reprintWindow.print();
            reprintWindow.close();
          }, 600);
          this.buttonLoading = false;
        });
    },
  },
};
</script>